<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="animated fadeIn vld-parent" style="height: 100%; background-color: white">
        <b-row style="padding-top: 2.75rem; padding-left: 30px; padding-right: 30px">
        <b-col>
            <md-card>
                <md-card-header style="border-bottom: 2px solid lightgray;">
                    <span class="font-lg"><b>Entwicklungsphase</b></span>
                </md-card-header>
                <md-card-content style="margin-top: 16px">
                    <b-row v-for="(item, index) in growing_state">
                        <b-col md="2">
                            <clear-icon v-if="canDelete" v-on:click="onDeleteGrowingState(index)" class="icon-1_5x hoverable-icon" fillColor="#16aa13" :size="72" style="color: red"></clear-icon>
                        </b-col>
                        <b-col md="8">
                            <p v-on:click="editItem(item, index)" class="font-lg hoverable">{{ item.text }}</p>
                        </b-col>
                        <b-col md="2">
                            <div class="hoverable" style="height: 1.25rem; width: 1.25rem !important; cursor: pointer;"
                                 v-bind:style="{ background: item.text1}"
                                 @click.stop="onEditColor(item)"></div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" style="margin-top: 5px">
                            <add-icon  v-on:click="onEnterGrowingState" class="icon-1_5x hoverable-icon" fillColor="#16aa13" :size="72" style="color: green"></add-icon>
                        </b-col>
                        <b-col md="10">
                            <b-form-input v-model="growing_state_add" placeholder="Entwicklungsphase hinzufügen" v-on:keyup.enter="onEnterGrowingState"></b-form-input>
                        </b-col>
                    </b-row>
                </md-card-content>
            </md-card>
        </b-col>
        <b-col>
            <md-card>
                <md-card-header style="border-bottom: 2px solid lightgray;">
                    <span class="font-lg"><b>Sicherheitserwartung</b></span>
                </md-card-header>
                <md-card-content style="margin-top: 16px">
                    <b-row v-for="(item, index) in security_expectation">
                        <b-col md="2">
                            <clear-icon v-if="canDelete" v-on:click="onDeleteSecurity(index)" class="icon-1_5x hoverable-icon" fillColor="#16aa13" :size="72" style="color: red"></clear-icon>
                        </b-col>
                        <b-col md="8">
                            <p v-on:click="editItem(item, index)" class="font-lg hoverable">{{ item.text }}</p>
                        </b-col>
                        <b-col md="2">
                            <div class="hoverable" style="height: 1.25rem; width: 1.25rem !important; cursor: pointer;"
                                 v-bind:style="{ background: item.text1}"
                                 @click.stop="onEditColor(item)"></div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" style="margin-top: 5px">
                            <add-icon v-on:click="onEnterSecurity" class="icon-1_5x hoverable-icon" fillColor="#16aa13" :size="72" style="color: green"></add-icon>
                        </b-col>
                        <b-col md="10">
                            <b-form-input v-model="security_expectation_add" placeholder="Sicherheitserwartung hinzufügen" v-on:keyup.enter="onEnterSecurity"></b-form-input>
                        </b-col>
                    </b-row>
                </md-card-content>
            </md-card>
        </b-col>
        <b-col>
            <md-card>
                <md-card-header style="border-bottom: 2px solid lightgray;">
                    <span class="font-lg"><b>Zustand</b></span>
                </md-card-header>
                <md-card-content style="margin-top: 16px">
                    <b-row v-for="(item, index) in condition">
                        <b-col md="2">
                            <clear-icon v-if="canDelete" v-on:click="onDeleteCondition(index)" class="icon-1_5x hoverable-icon" fillColor="#16aa13" :size="72" style="color: red"></clear-icon>
                        </b-col>
                        <b-col md="8">
                            <p v-on:click="editItem(item, index)" class="font-lg hoverable">{{ item.text }}</p>
                        </b-col>
                        <b-col md="2">
                            <div class="hoverable" style="height: 1.25rem; width: 1.25rem !important; cursor: pointer;"
                                 v-bind:style="{ background: item.text1}"
                                 @click.stop="onEditColor(item)"></div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" style="margin-top: 5px">
                            <add-icon v-on:click="onEnterCondition" class="icon-1_5x hoverable-icon" fillColor="#16aa13" :size="72" style="color: green"></add-icon>
                        </b-col>
                        <b-col md="10">
                            <b-form-input v-model="condition_add" placeholder="Zustand hinzufügen" v-on:keyup.enter="onEnterCondition"></b-form-input>
                        </b-col>
                    </b-row>
                </md-card-content>
            </md-card>
        </b-col>
        <b-col>
            <md-card>
                <md-card-header style="border-bottom: 2px solid lightgray;">
                    <span class="font-lg"><b>Kontrollintervall</b></span>
                </md-card-header>
                <md-card-content style="margin-top: 16px">
                    <b-row v-for="(item, index) in control_interval">
                        <b-col md="2">
                            <clear-icon v-if="canDelete" v-on:click="onDeleteInterval(index)" class="icon-1_5x hoverable-icon" fillColor="#16aa13" :size="72" style="color: red"></clear-icon>
                        </b-col>
                        <b-col md="10">
                            <p v-on:click="editItem(item, index)" class="font-lg hoverable">{{ item.text }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" style="margin-top: 5px">
                            <add-icon  v-on:click="onEnterInterval" class="icon-1_5x hoverable-icon" fillColor="#16aa13" :size="72" style="color: green"></add-icon>
                        </b-col>
                        <b-col md="10">
                            <b-form-input type="number" v-model="control_interval_add" placeholder="Kontrollintervall hinzufügen" v-on:keyup.enter="onEnterInterval"></b-form-input>
                        </b-col>
                    </b-row>
                </md-card-content>
            </md-card>
        </b-col>
    </b-row>
        <b-row style="padding-top: 37px; padding-left: 30px; padding-right: 30px">
            <b-col>
                <md-card>
                    <md-card-header style="border-bottom: 2px solid lightgray;">
                        <span class="font-lg"><b>Kontrollregeln</b></span>
                    </md-card-header>
                    <md-card-content style="margin-top: 16px">
                        <b-table striped hover responsive="sm" :items="interval_relation"
                                 :fields="interval_relation_fields">
                            <template v-slot:cell(growing_state)="data">
                                <span v-html="getGrowingState(data.item.growing_state)"></span>
                            </template>
                            <template v-slot:cell(security_expectation)="data">
                                <span v-html="getSecurityExpectation(data.item.security_expectation)"></span>
                            </template>
                            <template v-slot:cell(condition)="data">
                                <span v-html="getCondition(data.item.condition)"></span>
                            </template>
                            <template v-slot:cell(control_interval)="data">
                                <span v-html="getInterval(data.item.control_interval)"></span>
                            </template>
                            <template v-slot:cell(delete_edit)="data">
                                <edit-icon  v-on:click="editIntervalRelation(data.index, data.item)" class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72" style="color: green"></edit-icon>
                                <clear-icon v-on:click="deleteIntervalRelation(data.index, data.item)"  class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72" style="color: red"></clear-icon>
                            </template>
                        </b-table>
                        <b-row>
                            <b-col>
                                <b-button v-on:click="onNewRule" variant="primary" class="px-4 float-right" >Neue Regel anlegen</b-button>
                            </b-col>
                        </b-row>
                    </md-card-content>
                </md-card>
            </b-col>
        </b-row>

        <b-modal
                centered
                v-model="show"
                title="Text anpassen"
                cancel-title="Abbrechen"
                ok-title="Speichern"
                @ok="editOk"
        >
            <b-container fluid>
                <b-row class="mb-1 text-center">
                    <b-col>
                        <b-form-group
                                      :invalid-feedback="invalidModalText"
                                      :state="stateModalText">
                        <b-form-input v-model="modal_text" v-on:keyup.enter="editOk"
                                      :state="stateModalText"
                                      @input="clearError('modal_text')"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>

        <b-modal
                centered
                v-model="show_color"
                title="Farbe anpassen"
                cancel-title="Abbrechen"
                ok-title="Speichern"
                @ok="editColorOk"
        >
            <b-container fluid>
                <b-row class="mb-1 text-center">
                    <b-col>
                        <swatches-picker v-model="colors" />
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import ClearIcon from 'vue-material-design-icons/CloseCircle.vue';
    import AddIcon from 'vue-material-design-icons/PlusCircle.vue';
    import EditIcon from 'vue-material-design-icons/PencilCircle.vue';
    import {Server_URL} from "../../shared/utils";
    import DeleteIcon from "vue-material-design-icons/Delete";
    import { Swatches } from 'vue-color'

    export default {
        name: "ControlData",
        components: {
            DeleteIcon,
            ClearIcon,
            AddIcon,
            EditIcon,
            'swatches-picker': Swatches
        },
        computed: {
            stateModalText() {
                return this.modalTextError === "" ? undefined : false
            },

            invalidModalText() {
                return this.modalTextError;
            },
        },
        data() {
            return {
                loader: undefined,
                security_expectation: [],
                security_expectation_add: "",
                growing_state: [],
                growing_state_add: "",
                condition: [],
                condition_add: "",
                control_interval: [],
                control_interval_add: "",
                canDelete: true,

                interval_relation_fields: [
                    {key: "growing_state", label: 'Entwicklungsphase'},
                    {key: "security_expectation", label: 'Sicherheitserwartung'},
                    {key: "condition", label: 'Zustand'},
                    {key: "control_interval", label: 'Kontrollintervall'},
                    {key: 'delete_edit', label:""}
                ],
                interval_relation: [],
                show: false,
                modal_text: "",
                modal_item: {},
                modal_index: 0,
                modalTextError: "",
                show_color: false,
                colors: "",
                current: null,

            }
        },
        created() {
            this.showLoader();
            this.$http.get(
                Server_URL+'/baumkontrolle/config/control_config'
            ).then(this.responseOkGet, this.responseError)
        },
        methods: {
            onEditColor(item) {
                this.current = item;
                this.colors = item.text1;
                this.show_color = true;
            },
            editColorOk() {
                this.current.text1 = this.colors.hex;
                this.show_color = false;
                this.$http.patch(
                    Server_URL+'/baumkontrolle/config/constant_color/'+this.current.id,
                    {
                        text1: this.current.text1,
                    }
                ).then(this.responseOkDelete, this.responseError)
            },
            isBlank(str) {
                return (!str || str.trim().length === 0);
            },
            clearError(str) {
                switch (str) {
                    case "modal_text":
                        this.modalTextError = "";
                        break;
                }
            },
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            deleteConstant(constant, c_type) {
                if (constant.id === -1) {
                    return;
                }
                //this.showLoader();
                this.$http.delete(
                    Server_URL+'/baumkontrolle/config/constant/'+constant.id+'?c_type='+c_type
                ).then(this.responseOkDelete, this.responseError)
                for (let i = 0; i < this.interval_relation.length; i++) {
                    if (c_type === "control_interval") {
                        if(this.interval_relation[i].control_interval === constant.id) {
                            this.interval_relation[i].control_interval = 0;
                        }
                    } else {
                        this.interval_relation[i][c_type] = this.interval_relation[i][c_type].replace("|"+constant.id+"|", "");
                    }
                }
            },
            insertConstant(cType, cKey, cValue) {
                //this.showLoader();
                this.$http.post(
                    Server_URL+'/baumkontrolle/config/constant',
                    {
                        c_type: cType,
                        value: cKey,
                        text: cValue,
                    }
                ).then(this.responseOkInsert, this.responseError)
            },
            onEnterSecurity() {
                if (this.security_expectation_add === ""){
                    return;
                }
                let value = this.security_expectation_add;
                this.security_expectation.push({id: -1, text: value});
                this.security_expectation_add = "";
                this.insertConstant("security_expectation", 0, value);
            },
            onDeleteSecurity(index) {
                this.deleteConstant(this.security_expectation[index], "security_expectation");
                this.security_expectation.splice( index, 1 );
            },
            onEnterGrowingState() {
                if (this.growing_state_add === ""){
                    return;
                }
                let value = this.growing_state_add;
                this.growing_state.push({id: -1, text: value});
                this.growing_state_add = "";
                this.insertConstant("growing_state", 0, value);
            },
            onDeleteGrowingState(index) {
                this.deleteConstant(this.growing_state[index], "growing_state");

                this.growing_state.splice( index, 1 );
            },
            onEnterCondition() {
                if (this.condition_add === ""){
                    return;
                }
                let value = this.condition_add;
                this.condition.push({id: -1, text: value});
                this.condition_add = "";
                this.insertConstant("condition", 0, value);
            },
            onDeleteCondition(index) {
                this.deleteConstant(this.condition[index], "condition");

                this.condition.splice( index, 1 );
            },
            onEnterInterval() {
                if (this.control_interval_add === ""){
                    return;
                }
                let key = parseInt(this.control_interval_add);
                let value = "nicht nötig";
                if (Number.isNaN(key)) {
                    console.log(key);
                    this.control_interval_add = "";
                    return;
                } else if (key < 0) {
                    console.log(key);
                    this.control_interval_add = "";
                    return;
                } else if (key === 1) {
                    value = "1 Jahr";
                } else if (key < 91) {
                    value = key + " Jahre";
                } else {
                  const daysInYear = 366;

                  // 1. Calculate the raw decimal value for the years.
                  const decimalYears = key / daysInYear;

                  // 2. To round to the nearest 0.25, multiply by 4, round to the
                  //    nearest whole number, and then divide by 4.
                  const roundedYears = Math.round(decimalYears * 4) / 4;
                  value = roundedYears.toFixed(2).replace('.', ',') + " Jahre";

                }
                this.control_interval.push({id: -1, value: key, text: value});
                this.control_interval_add = "";
                this.insertConstant("control_interval", key, value);

            },
            onDeleteInterval(index) {
                this.deleteConstant(this.control_interval[index], "control_interval");

                this.control_interval.splice( index, 1 );
            },
            getGrowingState(states) {
                let splits = states.split("|");
                let text = "";
                let numStates = 0;
                for (let i = 0; i < splits.length; i++) {
                    let current = splits[i];
                    if (current !== "") {
                        let id = parseInt(current);
                        for (let j = 0; j < this.growing_state.length; j++) {
                            if (this.growing_state[j].id === id) {
                                text += (text === "" ? this.growing_state[j].text : " <b>oder</b> " + this.growing_state[j].text);
                                break;
                            }
                        }
                        numStates++;
                    }
                }
                if (text === "") {
                    text = "<b>nicht gesetzt</b>"
                } else if (numStates === this.growing_state.length) {
                    text = "unerheblich";
                }
                return text;
            },
            getSecurityExpectation(states) {
                let splits = states.split("|");
                let text = "";
                let numStates = 0;
                for (let i = 0; i < splits.length; i++) {
                    let current = splits[i];
                    if (current !== "") {
                        let id = parseInt(current);
                        for (let j = 0; j < this.security_expectation.length; j++) {
                            if (this.security_expectation[j].id === id) {
                                text += (text === "" ? this.security_expectation[j].text : " <b>oder</b> " + this.security_expectation[j].text);
                                break;
                            }
                        }
                        numStates++;
                    }
                }if (text === "") {
                    text = "<b>nicht gesetzt</b>"
                } else if (numStates === this.security_expectation.length) {
                    text = "unerheblich";
                }
                return text;
            },
            getCondition(states) {
                let splits = states.split("|");
                let text = "";
                let numStates = 0;
                for (let i = 0; i < splits.length; i++) {
                    let current = splits[i];
                    if (current !== "") {
                        let id = parseInt(current);
                        for (let j = 0; j < this.condition.length; j++) {
                            if (this.condition[j].id === id) {
                                text += (text === "" ? this.condition[j].text : " <b>oder</b> " + this.condition[j].text);
                                break;
                            }
                        }
                        numStates++;
                    }
                }
                if (text === "") {
                    text = "<b>nicht gesetzt</b>"
                } else if (numStates === this.condition.length) {
                    text = "unerheblich";
                }
                return text;
            },
            getInterval(state) {
                let text = "";
                for (let i = 0; i < this.control_interval.length; i++) {
                    if (this.control_interval[i].id === state) {
                        text = this.control_interval[i].text;
                        break
                    }
                }
                if (text === "") {
                    text = "<b>nicht gesetzt</b>"
                }
                return text;
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.security_expectation = response.body.constants_security_expectation;
                    this.growing_state = response.body.constants_growing_state;
                    this.condition = response.body.constants_condition;
                    this.control_interval = response.body.constants_control_interval;
                    this.canDelete = response.body.number_trees === 0;
                    this.interval_relation = response.body.interval_relations;
                } else {
                    console.log(response);
                }
            },
            responseOkDelete(response) {
                //this.hideLoader();
                if (response.status === 200) {
                    // ok
                } else {
                    console.log(response);
                }
            },
            responseOkInsert(response) {
                //this.hideLoader();
                if (response.status === 200) {
                    switch (response.body.c_type) {
                        case 'growing_state':
                            this.growing_state[this.growing_state.length-1].id = response.body.id;
                            break;
                        case 'condition':
                            this.condition[this.condition.length-1].id = response.body.id;
                            break;
                        case 'security_expectation':
                            this.security_expectation[this.security_expectation.length-1].id = response.body.id;
                            break;
                        case 'control_interval':
                            this.control_interval[this.control_interval.length-1].id = response.body.id;
                            break;
                    }
                } else {
                    console.log(response);
                }
            },
            editItem(item, index) {
                this.modal_index = index;
                this.modal_item = item;
                this.modal_text = item.text;
                this.show = true;
            },
            editOk(event) {
                if (this.validateModalText()) {
                    this.show = false;
                    this.modal_item.text = this.modal_text;
                    this.$http.patch(
                        Server_URL+'/baumkontrolle/config/constant/'+this.modal_item.id,
                        {
                            text: this.modal_item.text,
                        }
                    ).then(this.responseOkDelete, this.responseError)
                } else {
                    event.preventDefault();
                }
            },
            deleteIntervalRelation(index, item) {
                this.$http.delete(
                    Server_URL+'/baumkontrolle/config/interval_relation/'+item.id
                ).then(this.responseOkDelete, this.responseError);
                this.interval_relation.splice(index, 1);
            },
            editIntervalRelation(index, item) {
                this.$router.push({path: 'interval_relation/'+item.id});
            },
            onNewRule() {
                this.$router.push({path: 'interval_relation/'+0});
            },
            validateModalText() {
                if (this.isBlank(this.modal_text)) {
                    this.modalTextError = "Der neue Text darf nicht leer sein.";
                    return false;
                }
                return true;
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
        }

    }
</script>

<style scoped>

    .hoverable:hover {
        color: #23282c;
        background-color: rgba(0, 0, 0, 0.075);
        cursor: pointer;
    }

    .hoverable-icon:hover {
        cursor: pointer;
    }

</style>
